/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="financing" size=32 />
 */
const Financing = () => (
  <>
    <path
      d="M19.4871 3.59404L1.5353 10.451C1.1384 10.6026 0.94003 11.046 1.09223 11.4414L4.90343 21.3414C5.05563 21.7368 5.50076 21.9344 5.89766 21.7828L23.8495 14.9258C24.2464 14.7742 24.4448 14.3308 24.2926 13.9355L20.4814 4.03539C20.3292 3.64004 19.884 3.44244 19.4871 3.59404Z"
      fill="#B9DEFA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.67905 10.8243C1.48749 10.8975 1.3935 11.1105 1.46594 11.2986L5.27714 21.1987C5.34958 21.3868 5.56244 21.4826 5.75399 21.4095L23.7058 14.5525C23.8974 14.4793 23.9914 14.2663 23.9189 14.0782L20.1077 4.17809C20.0353 3.98993 19.8224 3.89415 19.6309 3.96731L1.67905 10.8243ZM0.718598 11.5841C0.486641 10.9815 0.78939 10.3077 1.39163 10.0777L19.3435 3.22072C19.9457 2.99069 20.6231 3.29009 20.8551 3.89263L24.6663 13.7927C24.8982 14.3952 24.5955 15.069 23.9932 15.2991L6.0414 22.1561C5.43916 22.3861 4.76176 22.0867 4.52981 21.4841L0.718598 11.5841Z"
      fill="#002D55"
    />
    <path d="M20.902 5.22727L1.49854 12.6387L2.31699 14.7648L21.7205 7.35331L20.902 5.22727Z" fill="#002D55" />
    <path
      d="M29.6618 14.8654H10.4353C10.0102 14.8654 9.66565 15.2086 9.66565 15.632V26.3577C9.66565 26.7811 10.0102 27.1244 10.4353 27.1244H29.6618C30.0868 27.1244 30.4314 26.7811 30.4314 26.3577V15.632C30.4314 15.2086 30.0868 14.8654 29.6618 14.8654Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4353 15.2654C10.2297 15.2654 10.0656 15.431 10.0656 15.6321V26.3577C10.0656 26.5588 10.2297 26.7244 10.4353 26.7244H29.6617C29.8674 26.7244 30.0314 26.5588 30.0314 26.3577V15.6321C30.0314 15.431 29.8674 15.2654 29.6617 15.2654H10.4353ZM9.26562 15.6321C9.26562 14.9863 9.79078 14.4654 10.4353 14.4654H29.6617C30.3062 14.4654 30.8314 14.9863 30.8314 15.6321V26.3577C30.8314 27.0035 30.3062 27.5244 29.6617 27.5244H10.4353C9.79078 27.5244 9.26562 27.0035 9.26562 26.3577V15.6321Z"
      fill="#002D55"
    />
    <path
      d="M27.2757 21.5814H24.197C23.772 21.5814 23.4274 21.9246 23.4274 22.348V23.1147C23.4274 23.5381 23.772 23.8814 24.197 23.8814H27.2757C27.7008 23.8814 28.0454 23.5381 28.0454 23.1147V22.348C28.0454 21.9246 27.7008 21.5814 27.2757 21.5814Z"
      fill="#B9DEFA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.197 21.9814C23.9914 21.9814 23.8273 22.147 23.8273 22.3481V23.1147C23.8273 23.3158 23.9914 23.4814 24.197 23.4814H27.2757C27.4814 23.4814 27.6454 23.3158 27.6454 23.1147V22.3481C27.6454 22.147 27.4814 21.9814 27.2757 21.9814H24.197ZM23.0273 22.3481C23.0273 21.7023 23.5525 21.1814 24.197 21.1814H27.2757C27.9202 21.1814 28.4454 21.7023 28.4454 22.3481V23.1147C28.4454 23.7605 27.9202 24.2814 27.2757 24.2814H24.197C23.5525 24.2814 23.0273 23.7605 23.0273 23.1147V22.3481Z"
      fill="#002D55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6978 17.9243C11.6978 17.7034 11.8768 17.5243 12.0978 17.5243H20.618C20.8389 17.5243 21.018 17.7034 21.018 17.9243C21.018 18.1452 20.8389 18.3243 20.618 18.3243H12.0978C11.8768 18.3243 11.6978 18.1452 11.6978 17.9243Z"
      fill="#002D55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6978 20.646C11.6978 20.4251 11.8768 20.246 12.0978 20.246H17.6086C17.8295 20.246 18.0086 20.4251 18.0086 20.646C18.0086 20.8669 17.8295 21.046 17.6086 21.046H12.0978C11.8768 21.046 11.6978 20.8669 11.6978 20.646Z"
      fill="#002D55"
    />
  </>
)

export default Financing
